import React from 'react';
import PropTypes from 'prop-types';

import { Dialog, DialogContent, DialogTitle } from '@mui/material';

import Button from '../../formElements/Button';

import AuditCircumstancesManagement from './AuditCircumstancesManagement';

import modal from '../../../commonStyles/modal.module.css';

const AuditCircumstancesModal = ({ label, isOpen, onClose }) => {
    return (
        <Dialog
            onClose={onClose}
            open={isOpen}
            onClick={(e) => e.stopPropagation()}
            className="muiDialogWrapper"
            id="auditModal">
            <div className={modal.modalHeader}>
                <DialogTitle>{label} Change History</DialogTitle>
            </div>
            <DialogContent>
                <>
                    <div className={modal.mainContent}>
                        <AuditCircumstancesManagement />
                    </div>
                    <div className={modal.actionButtons}>
                        <div className={modal.cancelButton}>
                            <Button id="auditModalButton" onClick={onClose} content="Close" />
                        </div>
                    </div>
                </>
            </DialogContent>
        </Dialog>
    );
};

AuditCircumstancesModal.propTypes = {
    label: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired
};

export default AuditCircumstancesModal;
